import { TaskTypes } from 'src/app/shared/models/tasks.model';
import { Params } from '@angular/router';
import { SidebarTabs, TaskOwnership } from '../../model/sidebar.model';

export const QueryParamsKeys = {
  sidebarTaskTypesSelection: 'sidebarTaskTypesSelection',
  sidebarSearchString: 'sidebarSearchString',
  sidebarTaskOwnership: 'sidebarTaskOwnership',
  sidebarActiveTab: 'sidebarActiveTab',
} as const;

export type QueryParamsKey =
  (typeof QueryParamsKeys)[keyof typeof QueryParamsKeys];

export interface QueryParamsDto {
  [QueryParamsKeys.sidebarSearchString]?: string;
  [QueryParamsKeys.sidebarTaskTypesSelection]?: TaskTypes[];
  [QueryParamsKeys.sidebarTaskOwnership]?: TaskOwnership;
  [QueryParamsKeys.sidebarActiveTab]?: SidebarTabs;
}

export type QueryParamsDtoValues = QueryParamsDto[keyof QueryParamsDto];

export interface QueryParamSerializer<T> {
  key: QueryParamsKey;
  deserializeQueryParamValue: (value: string) => T;
  serializeToQueryParamValue: (value: T) => string;
  keyIsIn: (params: Params) => boolean;
}

export interface Serializable<T> {
  serialize(value: T): string;
  deserialize(value: string): T;
}
